import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IButtonPayloadModel } from 'STORE/Messages/Message/Payload/ButtonsPayload/ButtonsPayload';

import { CommandButton } from '../CommandButton/CommandButton';
import { useBaseCommandButtonPresenter } from './BaseCommandButton.presenter';

interface IBaseBubbleButtonProps {
  groupId: string;
  button: IButtonPayloadModel;
}

export const BaseCommandButton: FC<IBaseBubbleButtonProps> = observer((props) => {
  const { button, groupId } = props;

  const presenter = useBaseCommandButtonPresenter({ groupId, button });

  return (
    <CommandButton
      onClick={presenter.onClick}
      title={button.title}
    />
  );
});
